// src/App.js
import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Navbar from "./components/Navbar";
import Sidebar from "./components/Sidebar";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Users from "./pages/Users";
import Entries from "./pages/Entries";
import { AuthProvider, useAuth } from "./context/AuthContext";
import EntryDetail from "./pages/EntryDetail";
import SingleUser from "./pages/SingleUser";
import UserRoutes from "./pages/UserRoutes";
import RouteEntriesDetail from "./pages/RouteEntriesDetail";
import DogObservation from "./pages/Observation";
import MasterFiles from "./pages/MasterFiles";
import History from "./pages/History";

const AppRoutes = () => {
  const { isAuthenticated, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  // initial sidebar state depends on width (desktop open by default)
  useEffect(() => {
    const setInitial = () => setSidebarOpen(window.innerWidth >= 992);
    setInitial();
    window.addEventListener("resize", setInitial);
    return () => window.removeEventListener("resize", setInitial);
  }, []);

  const toggleSidebar = () => setSidebarOpen((s) => !s);
  const closeSidebarOnMobile = () => {
    if (window.innerWidth < 992) setSidebarOpen(false);
  };

  if (!isAuthenticated) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  // Authenticated layout
  return (
    <>
      <Navbar onToggleSidebar={toggleSidebar} onLogout={logout} />
      <Sidebar open={sidebarOpen} onClose={closeSidebarOnMobile} />
      <div
        style={{
          marginTop: 60,
          marginLeft: sidebarOpen && window.innerWidth >= 992 ? 220 : 0,
          transition: "margin-left 240ms ease",
          minHeight: "calc(100vh - 60px)",
          background: "#f8fafc",
        }}
      >
        <Routes>
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/users" element={<Users />} />
          <Route path="/users/:id" element={<SingleUser />} />
          <Route path="/entries/surveyor/:id" element={<SingleUser />} />
          <Route path="/entries/survey/:id" element={<DogObservation />} />
          <Route path="/entries" element={<Entries />} />
          <Route path="/entries/route/:id" element={<RouteEntriesDetail />} />
          <Route path="/entries/entry/:id" element={<EntryDetail />} />
          <Route path="/routes" element={<UserRoutes />} />
          <Route path="/master-files" element={<MasterFiles />} />
          <Route path="/history" element={<History />} />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </div>
    </>
  );
};

const App = () => {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
};

export default App;
